import React from "react";
import { PageContextProvider } from "./usePageContext";
import { Navigation } from "../components/Navigation";
import { Footer } from "../components/Footer";
import { BackToTop } from "../components/BackToTop";
import "../index.css";
import type { PageContext } from "./types";

export function PageShell({
  children,
  pageContext,
}: {
  children: React.ReactNode;
  pageContext: PageContext;
}) {
  return (
    <React.StrictMode>
      <PageContextProvider pageContext={pageContext}>
        <div className="min-h-screen flex flex-col">
          <Navigation />
          <main className="flex-grow w-full max-w-screen overflow-x-hidden">
            {children}
          </main>
          <BackToTop />
          <Footer />
        </div>
      </PageContextProvider>
    </React.StrictMode>
  );
}
